function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Share this item");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "share-line",
  transform: "translate(0.000000, -1.000000)",
  fill: "#3F3F3D"
}, React.createElement("path", {
  d: "M23,25 C21.346,25 20,23.654 20,22 C20,20.346 21.346,19 23,19 C24.654,19 26,20.346 26,22 C26,23.654 24.654,25 23,25 M5,25 C3.346,25 2,23.654 2,22 C2,20.346 3.346,19 5,19 C6.654,19 8,20.346 8,22 C8,23.654 6.654,25 5,25 M15,3 C16.654,3 18,4.346 18,6 C18,7.654 16.654,9 15,9 C13.346,9 12,7.654 12,6 C12,4.346 13.346,3 15,3 M23,17 C20.581,17 18.564,18.718 18.101,21 L9.899,21 C9.702,20.027 9.221,19.158 8.548,18.479 L13.669,10.798 C14.096,10.917 14.536,11 15,11 C17.762,11 20,8.761 20,6 C20,3.239 17.762,1 15,1 C12.239,1 10,3.239 10,6 C10,7.574 10.742,8.961 11.879,9.878 L6.882,17.373 C6.301,17.136 5.667,17 5,17 C2.239,17 0,19.238 0,22 C0,24.762 2.239,27 5,27 C7.419,27 9.436,25.282 9.899,23 L18.101,23 C18.564,25.282 20.581,27 23,27 C25.762,27 28,24.762 28,22 C28,19.238 25.762,17 23,17",
  id: "Fill-1"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "26px",
    viewBox: "0 0 28 26",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/share-line.2210e642.svg";
export { SvgComponent as ReactComponent };